import { createStore } from 'vuex'
import { autorenewal, order, coupons, ui, subscription } from "../store/modules";
export const store = createStore({
    modules: {
        order,
        ui,
        coupons,
        autorenewal,
        subscription
    }
});